import { render } from "./CarCard.vue?vue&type=template&id=12f8be52"
import script from "./CarCard.vue?vue&type=script&lang=js"
export * from "./CarCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__